'use strict';

export default class Card {
  constructor() {
    var ellipsesElement = document.getElementsByClassName('ellipses');
    Array.prototype.forEach.call(ellipsesElement, function(el) {
        window.$clamp( el, {clamp: 2} );
    });

  }
}
